import axios from 'axios';
import tableUtil from '../../utils/table';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'topics', { params })
      .then(({ data }) => {
        let dataRes = {};
        dataRes.data = data.data;
        if (data.data) {
          dataRes.data = dataRes.data;
        }
        dataRes.meta = data.pagination ? { pagination: data.pagination } : tableUtil.mockupMeta(dataRes.data.length);
        resolve(dataRes);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
